import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-final-step',
  templateUrl: './final-step.component.html',
  styleUrls: ['./final-step.component.scss']
})
export class FinalStepComponent implements OnInit {
  @Output() nextStepEvent = new EventEmitter();
  constructor() { }

  ngOnInit(): void {
  }

  nextStep(): void {
    this.nextStepEvent.emit({
      nextStep: 'close'
    });
  }
}
